export default __webpack_public_path__ + "static/media/boa.b324629f.webp";